<template>
  <!-- Полоса значков раскрывается при наведении, но рабочую область не двигает:
       ширину для разметки держит правило .nav--overlay в теме, а меню
       накрывает страницу собой. Раньше страница уезжала вправо ровно тогда,
       когда оператор вёл мышь к нужной строке таблицы. -->
  <v-navigation-drawer
    app
    :value="isMobile ? drawer : mode !== 'hidden'"
    :temporary="isMobile"
    :expand-on-hover="!isMobile && mode === 'overlay'"
    :mini-variant="!isMobile && mini"
    @update:mini-variant="mini = $event"
    class="navigator"
    clipped
    :width="isMobile ? 300 : 375"
    @input="onInput"
  >
    <v-list dense nav>
      <template v-for="(item, index) in active_links">
        <v-list-group
          v-if="item.children"
          :key="`link-${item.id}`"
          v-model="item.model"
          :prepend-icon="item.icon"
          append-icon="mdi-chevron-down"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-html="item.text"/>
            </v-list-item-content>
          </template>
          <v-list-item
            v-for="child in item.children"
            :key="`c-link-${child.id}`"
            :to="child.link"
            link
          >
            <v-list-item-action v-if="child.icon">
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title v-html="child.text"/>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item
          v-else
          :key="item.id"
          :to="item.link"
          link
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title v-html="item.text"/>
          </v-list-item-content>
        </v-list-item>

        <!-- Разделитель отбивает пункты друг от друга: список длинный, и без
             него разделы читались сплошной лентой. Последнему не нужен. -->
        <v-divider
          v-if="index < active_links.length - 1"
          :key="`divider-${item.id}`"
          class="navigator__divider"
        />
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from 'vuex'
import { canVisit } from '@/shared/lib/access'

// Боковое меню. Набор пунктов зависит от того, кто вошёл и открыта ли смена:
// без смены работать не с чем, поэтому до её открытия видны только главная и
// список смен.
export default {
  name: 'NavPanel',
  data () {
    return {
      mini: true,
      links: [
        { id: 1, text: 'Главная', link: '/', icon: 'mdi-view-dashboard' },
        { id: 2, text: 'Смены', link: '/work_shifts', icon: 'mdi-account-network' }
      ],
      admin_links: {
        id: 20,
        icon: 'mdi-shield-account',
        text: 'Настройки администратора',
        model: false,
        menu_slug: 'settings',
        children: [
          { id: 37, text: 'Роли и права', link: '/access-roles', icon: 'mdi-shield-key-outline' },
          { id: 21, text: 'Пользователи', link: '/users', icon: 'mdi-account-group' },
          { id: 22, text: 'Компании', link: '/companies', icon: 'mdi-handshake' },
          { id: 23, text: 'Справочник для отчётов', link: '/report-services', icon: 'mdi-file-document-edit' },
          { id: 24, text: 'Инвентаризация машин', link: '/inventory-vehicles', icon: 'mdi-car-3-plus' },
          { id: 26, text: 'Клиентские аккаунты', link: '/client-users', icon: 'mdi-account-key' },
          { id: 36, text: 'Мобильное приложение', link: '/mobile-app-releases', icon: 'mdi-cellphone-arrow-down' },
        ]
      },
      main_links: [
        { id: 1, text: 'Главная', link: '/', icon: 'mdi-view-dashboard' },
        { id: 2, text: 'Смены', link: '/work_shifts', icon: 'mdi-account-network' },
        { id: 3, text: 'Календарь смен', link: '/calendar', icon: 'mdi-calendar-month' },
        { id: 4, text: 'Принятые машины', link: '/unload_vehicles', icon: 'mdi-car-arrow-left' },
        { id: 5, text: 'Отгруженные машины', link: '/load_vehicles', icon: 'mdi-car-arrow-right' },
        { id: 6, text: 'Заявки на отгрузку', link: '/auto_carriers', icon: 'mdi-truck-delivery' },
        { id: 27, text: 'Заявки на затарку', link: '/stuffing-orders', icon: 'mdi-package-variant-closed' },
        { id: 28, text: 'Приёмка оборуд./крепежа', link: '/cargo-unload', icon: 'mdi-forklift' },
        { id: 33, text: 'Карта площадки', link: '/yard-map', icon: 'mdi-map-marker-radius' },
        { id: 7, text: 'Статистика перемещений', link: '/operations', icon: 'mdi-car-multiple' },
        {
          id: 8,
          icon: 'mdi-file-multiple',
          text: 'Работа с документами',
          model: false,
          menu_slug: 'documents',
          children: [
            { id: 25, text: 'Автовозы', link: '/auto-trucks', icon: 'mdi-truck' },
            { id: 9, text: 'Документы поездов', link: '/document-trains', icon: 'mdi-transfer' },
            { id: 10, text: 'Статус контейнеров', link: '/container-tickets', icon: 'mdi-table-network' },
            { id: 11, text: 'Сводный отчёт контейнеров', link: '/table-report-containers', icon: 'mdi-table-large' },
            { id: 12, text: 'Состояние документов машин', link: '/vehicle_tickets', icon: 'mdi-car-info' },
            { id: 29, text: 'Оборудование', link: '/equipments', icon: 'mdi-toolbox' },
            { id: 30, text: 'Крепёж', link: '/fastenings', icon: 'mdi-wrench' },
            { id: 13, text: 'Реестр по хранению автомобилей', link: '/store_report', icon: 'mdi-store-24-hour' },
            { id: 14, text: 'Бухгалтерия', link: '/bookkeeping', icon: 'mdi-book-open' },
            { id: 34, text: 'Заявки клиентов', link: '/client-orders', icon: 'mdi-account-arrow-right' },
            { id: 35, text: 'Обращения клиентов', link: '/client-threads', icon: 'mdi-forum-outline' },
          ]
        },
        {
          id: 15,
          icon: 'mdi-book-open-variant',
          text: 'Настройки и справочники',
          model: false,
          menu_slug: 'settings',
          children: [
            { id: 16, text: 'Дилер коды', link: '/dealers', icon: 'mdi-barcode' },
            { id: 17, text: 'Справочник услуг', link: '/services', icon: 'mdi-security-network' },
            { id: 18, text: 'Контейнера', link: '/containers', icon: 'mdi-cube' },
            { id: 19, text: 'Ряды', link: '/car-parks', icon: 'mdi-car-multiple' },
            { id: 31, text: 'Модели крепежа', link: '/fastening-models', icon: 'mdi-shape-outline' },
            { id: 32, text: 'Стили', link: '/styleguide', icon: 'mdi-palette-swatch' },
          ]
        },
      ]
    }
  },
  computed: {
    ...mapState(['active_links', 'user', 'work_shift']),
    mode () {
      return this.$store.state.nav_mode
    },
    // На телефоне меню выезжает поверх страницы по кнопке в шапке и
    // закрывается после перехода — режимов полосы и закрепления там нет.
    isMobile () {
      return this.$vuetify.breakpoint.smAndDown
    },
    drawer () {
      return this.$store.state.nav_drawer
    }
  },
  watch: {
    // Закреплённое меню всегда раскрыто; в режиме полосы шириной управляет
    // expand-on-hover, и начальное состояние — свёрнутое.
    mode: {
      immediate: true,
      handler (value) {
        this.mini = value !== 'pinned'
      }
    },
    $route () {
      if (this.isMobile) this.$store.commit('update_nav_drawer', false)
    },
    user: {
      immediate: true,
      handler () {
        this.updateActiveLinks()
      },
      deep: true
    },
    work_shift: {
      handler () {
        this.updateActiveLinks()
      },
      deep: true
    }
  },
  methods: {
    // Vuetify сам закрывает выезжающее меню по клику мимо — сохраняем это в
    // стор, иначе кнопка в шапке считала бы меню открытым. На десктопе
    // сворачивание полосы по наведению сюда же и приходит — его игнорируем.
    onInput (value) {
      if (this.isMobile) this.$store.commit('update_nav_drawer', value)
    },

    updateActiveLinks () {
      const links = []

      if (Object.keys(this.user).length > 0) {
        if (Object.keys(this.work_shift).length > 0) links.push(...this.main_links)
        else links.push(...this.links)

        if (this.user.admin) links.push(this.admin_links)
        else if (canVisit(this.user, '/client-users')) links.push({ id: 26, text: 'Клиентские аккаунты', link: '/client-users', icon: 'mdi-account-key' })
      }

      const allowed = links.map(item => item.children ? { ...item, children: item.children.filter(child => canVisit(this.user, child.link)) } : item).filter(item => item.children ? item.children.length : canVisit(this.user, item.link))
      this.$store.commit('update_active_links', allowed)
    }
  }
}
</script>

<style scoped>
/* Тоньше обычной линии: разделителей в списке два десятка, и обычной
   границей они бы расчертили меню сильнее, чем сам список. */
.navigator__divider {
  margin: 2px 8px;
  border-color: var(--sts-line-soft) !important;
}
</style>
